module.exports = __webpack_public_path__ + "img/group-icon.41dde83c.svg";